module.exports = __webpack_public_path__ + "static/media/b-sci-major-24_LR.c8858330.jpg";